module.exports = __webpack_public_path__ + "static/media/IMG_5938.51195f53.JPG";